import React, { useState } from 'react';
import {
  Shield, Server, Settings, Cloud, Zap, TrendingUp, Play, ArrowRight, ChevronDown,
  Phone, Mail, MapPin, Award, CheckCircle
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const Clouds = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const services = [
    {
      icon: <Settings className="w-8 h-8 text-blue-500" />,
      title: "Cloud Consulting",
      description: "Build Enterprise SaaS Cloud Strategy with Cloud Computing, Cloud Assessment for Infrastructure, Application, DevOps"
    },
    {
      icon: <Cloud className="w-8 h-8 text-blue-500" />,
      title: "Cloud Native Application",
      description: "Architect, design and build cloud native applications on multi-cloud platform systems"
    },
    {
      icon: <Server className="w-8 h-8 text-blue-500" />,
      title: "SaaS Services: Consulting",
      description: "Azure application architecture, development, consulting for SaaS and creating a new application"
    },
    {
      icon: <Shield className="w-8 h-8 text-blue-500" />,
      title: "Cloud Platform Services",
      description: "Design, integrate multi-cloud solutions, DevOps & CI/CD Services"
    }
  ];

  const reasons = [
    "A Experience of 10+ Cloud Consultants with 500+ person-years of experience",
    "Deep understanding of application platform based on past assessments and engagements",
    "Time tested and proven cloud reference architectures for varied industries",
    "Reference Architecture Libraries for applications and infrastructure",
    "Automated Unified Assessment Tool",
    "Strong governance to ensure collaboration between cloud platforms and on-premise infrastructure"
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Header />
      {/* Hero Section - Dark */}
      <section className="bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50 py-20 relative overflow-hidden">
        <div className="absolute top-10 right-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-16 h-16 bg-indigo-200 rounded-full opacity-60 animate-bounce"></div>
        <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-cyan-200 rounded-full opacity-40 animate-pulse"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-medium mb-6">
                <Award className="h-4 w-4 mr-2" />
                Cloud Offerings Made Simple
              </div>

              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Support <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Cloud
                </span> Offerings

              </h1>

              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Many enterprises recognize the cloud's potential but struggle to envision its impact and develop a clear strategy. Anvitech Solutions bridges this gap with expert cloud-native services, offering everything from guidance and best practices to execution.
              </p>


            </div>

            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
                <div className="mb-6">
                  <video
                    className="w-full h-64 rounded-2xl object-cover"
                    autoPlay
                    muted
                    loop
                    src="/cloudOffering.mp4"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid - Dark */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Our <span className="text-blue-400">Cloud Services</span>
            </h3>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Comprehensive cloud solutions tailored to your business needs
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="text-center p-6 bg-gray-800 rounded-lg hover:shadow-lg transition-all hover:bg-gray-700">
                <div className="flex justify-center mb-4">
                  {service.icon}
                </div>
                <h4 className="text-xl font-semibold text-white mb-3">{service.title}</h4>
                <p className="text-gray-300 text-sm">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* About Section - Light */}




      <section className="py-20 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="./cloudService.png"
                alt="Description of your image"
                className="w-full h-auto max-h-96 rounded-lg shadow-lg object-contain"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">
                About Our <span className="text-blue-600">Support Cloud</span> Offerings
              </h3>
              <p className="text-gray-700 mb-6">
                Enterprises are abandoning traditional on-premise cost from
                Data IT infrastructure and move to a more agile infrastructure
                which is not only cost-effective but also helps them focus on their
                core business areas.
              </p>
              <p className="text-gray-700 mb-6">
                While enterprises are aware that the great part of their worry can
                be solved by migrating to the cloud but they always face a
                challenge on "What can the Cloud do for them" becomes difficult
                for enterprises to have one cohesive view of what cloud can do for
                them.
              </p>
              <div className="space-y-4">
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-semibold text-gray-900">DAY (1): Assessment & Advisory Services</h4>
                  <p className="text-gray-600">Cloud advisory services, assessment and roadmap development</p>
                </div>
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-semibold text-gray-900">DAY (2): Design, Designing application architecture</h4>
                  <p className="text-gray-600">Cloud services, platform, security and goals</p>
                </div>
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-semibold text-gray-900">DAY (3): Support, Deploy, Automate & manage</h4>
                  <p className="text-gray-600">Application and Infrastructure analytics, implement cloud computing platforms</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Migration Advantages Section - Dark */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              <span className="text-blue-400">Key advantages for enterprises</span> to migrate their IT infrastructure
            </h3>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Transform your business with cloud migration benefits
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Settings className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Manage the IT resources better and focus on your core business
              </h4>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Access to Global resources without worrying of IT failure or sudden spike in business demand or sudden ramp down
              </h4>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Server className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Reduction in overall Operational and Management Cost as cloud gives the options of pay as you go and pay as per usage
              </h4>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Cloud className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Offload the management and availability responsibilities to a specialised cloud service provider
              </h4>
            </div>
          </div>
        </div>
      </section>
      {/* Cloud Migration Section - Light */}

      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}

          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
              “Ready to Scale with the Cloud?”
            </h2>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              <Play className="w-5 h-5 group-hover:animate-bounce" />
              <span>Get In Touch</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Clouds;